import { render } from "./index.vue?vue&type=template&id=530b25eb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=530b25eb&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-530b25eb"

export default script